import React from "react";
import { useStyles } from '../styles/CodeJamFindProjectCard.styles';
import { useStyles as useGeneralStyles } from '../styles/CodeJamModal.styles';

import Typography from "@material-ui/core/Typography";
import TextCustomButton from "@/components/text-button/text-button";

import CodeJamFind from "@/images/ide/codeJam-find.svg";

const CodeJamFindProjectCard = ({ onButtonClick }) => {
  const classes = useStyles();
  const generalClasses = useGeneralStyles();

  return <>
    <Typography className={generalClasses.tabElementHeader}>Continue working on a project</Typography>
    <div className={classes.content}>
      <div>
        <div className={classes.textSelected}>Check out your personal library under My Projects</div>
      </div>
      <div className={classes.logo}>
        <img
          alt="Check out your personal library under My Projects"
          className={classes.codeJamLogo}
          src={CodeJamFind}
        />
      </div>
    </div>
    <div className={classes.controls}>
      <TextCustomButton
        onClick={onButtonClick}
        className={classes.viewBtnIDE}
        type="submit"
        mode="ide"
        label="My Projects">
      </TextCustomButton>
    </div>
  </>
}

export default CodeJamFindProjectCard;
